import React from 'react';
import logo from 'assets/Images/bw-avatar.svg';
import { FlexBox } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

const AITyping = () => {
  return (
    <FlexBox gap="8px" alignSelf="flex-start">
      <img src={logo} alt="logo" className="bw-logo" />
      <FlexBox
        alignItems="center"
        justifyContent="flex-start"
        UNSAFE_className="msg-container typing-container"
        gap="12px"
      >
        <FontAwesomeIcon
          icon={faCircle}
          color="#FCD917"
          style={{ fontSize: '14px' }}
          className="point"
        />
        <FontAwesomeIcon
          icon={faCircle}
          color="#FCD917"
          style={{ fontSize: '14px' }}
          className="point"
        />
        <FontAwesomeIcon
          icon={faCircle}
          color="#FCD917"
          style={{ fontSize: '14px' }}
          className="point"
        />
      </FlexBox>
    </FlexBox>
  );
};

export default AITyping;
